import { useQuery } from '@shared/modules/use-query/hooks'
import { useCallback, useMemo } from 'react'
import { Doctor } from '../types'
import { DoctorsService } from '../services'

export const useDoctorList = (
  { clinicId, serviceIds }: { clinicId?: number | string; serviceIds?: (number | string)[] } = {},
  enabled: boolean = true,
) => {
  return useQuery<Doctor[]>(
    useCallback(async () => {
      const result = await DoctorsService.getAll({ page: 1, per_page: 5000, service_id: serviceIds, clinic_id: clinicId })
      if (result.status === 200) {
        return result.data
      } else {
        throw new Error(result.data)
      }
    }, [clinicId, serviceIds]),
    useMemo(() => ({ initialData: [], enabled }), [enabled]),
  )
}
